import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { AnketsScreen, AnketaScreen, SignInScreen } from 'screens';
import { PrivateRoute, NotFoundPage } from 'components';
import { anketsStore } from 'stores';
import { stripTrailingSlash } from 'utils/string';

export default () => (
  <Switch>
    <PrivateRoute path="/" exact>
      <AnketsScreen />
    </PrivateRoute>
    <PrivateRoute
      path="/ankets/:id"
      render={({ match }) => {
        anketsStore.setAnketId(match.params.id);
        const normalizedUrl = stripTrailingSlash(match.url);

        return (
          <Switch>
            <Redirect from={normalizedUrl} to={`${normalizedUrl}/main`} exact />
            <Route path={normalizedUrl}>
              <AnketaScreen />
            </Route>
          </Switch>
        );
      }}
    />
    <Route path="/signin" exact>
      <SignInScreen />
    </Route>
    <Route>
      <NotFoundPage />
    </Route>
  </Switch>
);
